import * as tslib_1 from "tslib";
/* I75 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Lock = /** @class */ (function (_super) {
    tslib_1.__extends(Lock, _super);
    function Lock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lock.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M9.606 12.168V8.601a2.839 2.839 0 0 1 2.833-2.797 2.84 2.84 0 0 1 2.832 2.811v3.58c0 .123.019.482.21.482h1.37c.224 0 .228-.402.225-.5V8.6a4.635 4.635 0 1 0-9.27 0l-.003 3.567H6.515a.517.517 0 0 0-.515.515v6.8c0 .285.232.517.515.517h11.848a.517.517 0 0 0 .515-.516v-6.8a.517.517 0 0 0-.515-.516H9.606zM14.07 16.1a1.63 1.63 0 1 1-3.261 0 1.63 1.63 0 0 1 3.26 0z" })))));
    };
    return Lock;
}(React.Component));
export { Lock };
export default Lock;
//# sourceMappingURL=Lock.js.map